export default __webpack_public_path__ + "static/media/10.1795434d.png";